import { Checkbox } from '@mui/material';

const CheckBox = ({ checked, setChecked, disabled }) => {
  return (
    <Checkbox
      size="small"
      inputProps={'aria-label:'}
      checked={checked}
      onClick={(e) => {
        setChecked(e);
      }}
      sx={checkboxStyle}
    />
  );
};

export default CheckBox;

const checkboxStyle = {
  padding: 0,
  color: '#97A1B4',
  '&.Mui-checked': {
    color: '#7D7D99',
  },
};
